<template>
  <div class="w-full flex justify-center">
    <el-checkbox :size="'large'" v-model="check" @change="handleCheckChange"> </el-checkbox>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  setup() {
    const check = ref()

    return {
      check,
    }
  },
  mounted() {
    /* @ts-ignore */
    if (this.params.data.bmID) {
      this.check = true
    }
  },
  methods: {
    handleCheckChange(event: any) {
      /* @ts-ignore */
      this.params.handleCheckChange(event, this.params.data, this.updateCheck)
    },
    updateCheck(value: any) {
      this.check = value;
    }
  }
})
</script>
